import Layout from '@/layout/TheLayout.vue'

export default [
  {
    path: '/',
    name: 'Policies',
    meta: {
      title: 'Políticas',
      showInSidebar: false
    },
    component: Layout,
    children: [
      {
        path: '/politicas/whatsapp_business/',
        name: 'WhatsApp Business',
        component: () => import('@/pages/Dashboard/Policies/WhatsAppBusiness'),
        meta: {
          showInSidebar: false,
          title: 'WhatsApp Business'
        }
      }
    ]
  }
]
